<template>
    <div class="list">
        <div class="top">
            <div class="topItem">
                <p>工  种：</p>
                <el-form inline ref="searchform" class="searchform" size="small">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item>
                                <el-select v-model="workTypeTitle" filterable clearable :remote="true"
                                    :remote-method="getWorkType" @change="getProductList">
                                    <el-option style="max-width:300px;" :label="v.title" :value="v.title"
                                        v-for="(v, i) in workTypeList" :key="i">
                                        <template v-if="v.id">
                                            <span>{{ v.title }}</span>
                                        </template>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <div class="topItem">
                <p>险  种：</p>
                <div class="tagBox" :style="{ height: cateMore ? 'auto' : '38px' }">
                    <p :class="product_cate.length == 0 ? 'activate' : ''" @click="tabBtn('product_cate')">
                        不限
                    </p>
                    <span v-for="(item, index) in proArray" :key="index"
                        :class="product_cate.includes(item.id) ? 'activate' : ''" @change="getProductList"
                        @click="tabBtn('product_cate', item.id)">
                        {{ item.title }}
                    </span>
                </div>
                <p class="moreBtn" @click="cateMore ? (cateMore = false) : (cateMore = true)">
                    更多
                    <i :class="cateMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                </p>
            </div>
            <div class="topItem">
                <p>保险公司：</p>
                <div class="tagBox" :style="{ height: companyMore ? 'auto' : '38px' }">
                    <p :class="company_id.length == 0 ? 'activate' : ''" @click="tabBtn('company_id')">
                        不限
                    </p>
                    <span v-for="(item, index) in iCompanyArray" :key="index"
                        :class="company_id.includes(item.id) ? 'activate' : ''" @change="getProductList"
                        @click="tabBtn('company_id', item.id)">
                        {{ item.name }}
                    </span>
                </div>
                <p class="moreBtn" @click="companyMore ? (companyMore = false) : (companyMore = true)">
                    更多
                    <i :class="companyMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                </p>
            </div>
            <div class="topItem">
                <p>标签：</p>
                <div>
                    <el-checkbox-group v-model="productLabel" @change="getProductList">
                        <el-checkbox label="1">新品</el-checkbox>
                        <el-checkbox label="2">高拥</el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
            <div class="topItem commission">
                <p>佣金范围：</p>

                <div>
                    <span> {{ commissionScope[0] }}% ~ {{ commissionScope[1] }}% </span>
                    <el-slider v-model="commissionScope" range :min="0" :max="100" @change="changCommScope">
                    </el-slider>
                </div>
            </div>
            <div class="topItem">
                <p>支付方式：</p>
                <div class="tagBox" :style="{ height: cateMore ? 'auto' : '38px' }">
                    <p :class="paytype.length == 0 ? 'activate' : ''" @click="tabBtn('paytype')">
                        不限
                    </p>
                    <span v-for="(item, index) in payTypeArray" :key="index"
                        :class="paytype.includes(item.id) ? 'activate' : ''" @change="getProductList"
                        @click="tabBtn('paytype', item.id)">
                        {{ item.title }}
                    </span>
                </div>
                <p class="moreBtn" @click="cateMore ? (cateMore = false) : (cateMore = true)">
                    更多
                    <i :class="cateMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                </p>
            </div>
            <div class="cotImg">
                <div @click="cotImg('0')" :class="cotImgNum != '1' ? 'activate' : ''">
                    <i class="icon-qiapianxingshi iconfont"></i>
                </div>
                <div @click="cotImg('1')" :class="cotImgNum == '1' ? 'activate' : ''">
                    <i class="icon-liebiaoxingshi iconfont"></i>
                </div>
            </div>
        </div>
        <div class="list_bottomBox">
            <div class="cardBox" v-if="cotImgNum != 1">
                <div class="item" @click="skip(item.product_id)" v-for="(item, index) in tableData" :key="index">
                    <div class="imgBox">
                        <img :src="item.product_list_img[0].url" alt="" v-if="item.product_list_img" />
                    </div>
                    <div class="textBox">
                        <p>{{ item.product_name }}</p>
                        <span>
                            <i class="iconfont icon-zhiye"></i> {{ item.product_cate }}
                        </span>
                        <span><i class="iconfont icon-qiandai"></i> {{ item.insured_amount }}
                        </span>
                        <div>
                            <div>查看详情</div>
                            <p v-if="isCanCommission == 1">
                                佣金： <span>{{ item.proCommission }}%</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <el-table :data="tableData" stripe size="small" style="width: 100%" v-else>
                <el-table-column type="index" label="序号" width="100">
                </el-table-column>
                <el-table-column prop="product_name" label="产品名称" min-width="300">
                </el-table-column>
                <el-table-column prop="company_name" label="所属保司" min-width="150">
                </el-table-column>
                <el-table-column prop="product_cate" label="险种类型" min-width="150">
                </el-table-column>
                <el-table-column prop="insure_type" label="保障周期" min-width="120">
                </el-table-column>
                <el-table-column label="佣金比例" width="100" v-if="isCanCommission == 1">
                    <template slot-scope="scope">{{ scope.row.proCommission }}%</template>
                </el-table-column>
                <el-table-column prop="product_label" label="不属于承保范围行业" min-width="200" show-overflow-tooltip>
                    <!-- <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>拒保行业：</p>
              <p>{{ scope.row.product_label }}</p>
              <div
                slot="reference"
                class="name-wrapper"
                style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
              >
                {{ scope.row.product_label }}
              </div>
            </el-popover>
          </template> -->
                </el-table-column>
                <el-table-column prop="address" label="操作" width="100" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" @click="skip(scope.row.product_id)">
                            投保
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import { getCompany, getProductCate } from "@/api/public";
import { getProductList } from "@/api/list";
import { getAllWorkTypeSelect } from "@/api/insure";
export default {
    name: "list",
    data() {
        return {
            isCanCommission: this.$store.getters.isCanCommission, //是否展示佣金
            cotImgNum: localStorage.getItem("cotImgNum"), //列表展示形式,储存在本地储存
            cateMore: false, //险种更多
            companyMore: false, //保司更多
            iCompanyArray: [], //保司列表
            company_id: [], //保司选中
            proArray: [], //产品分类列表
            product_cate: [], //产品分类选中
            commissionScope: [0, 100], //佣金范围
            productLabel: [],
            tableData: [],
            oldTableData: [], //旧数据
            workTypeList: [],
            workTypeTitle: '',
            paytype: [],
            payTypeArray: [
                { id: 1, title: "线上支付" },
                { id: 2, title: "线下支付" },
                { id: 3, title: "线上、线下支付" },
            ],
            tabLock: false,
        };
    },
    mounted() {
        // 获取保司
        this.getCompany();
        // 获取产品分类
        this.getProductCate();
        // 获取产品列表
        // this.getProductList();
    },
    methods: {
        getWorkType(e) {
            getAllWorkTypeSelect({ 'title': e }).then(res => {
                this.workTypeList = res.data
            });
        },
        skip(e) {
            // 页面跳转
            let _url = this.$router.resolve({
                path: "/insure/detail",
                query: { product_id: e }
            });
            window.open(_url.href, "_blank");
        },
        // 获取保司
        getCompany() {
            let that = this;
            getCompany()
                .then(function (res) {
                    console.log(res);
                    if (res.code == 1) {
                        that.iCompanyArray = res.data;
                    } else {
                        that.$message.error(res.msg);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        // 获取产品分类
        getProductCate() {
            let that = this;
            getProductCate({ identi: 1 })
                .then(function (res) {
                    console.log(res);
                    if (res.code == 1) {
                        that.proArray = res.data;
                    } else {
                        that.$message.error(res.msg);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        /* workTypeChange(e){
            console.log(this.workTypeTitle,e)
        }, */
        getProductList() {
            if (this.tabLock) return; // 阻止连续点击
            let that = this;
            let _data = {};
            if (that.product_cate) {
                _data.product_cate = that.product_cate;
            }
            if (that.company_id) {
                _data.company_id = that.company_id;
            }
            if (that.productLabel) {
                _data.productLabel = that.productLabel;
            }
            if (that.workTypeTitle) {
                _data.workTypeTitle = that.workTypeTitle;
            }
            if (that.paytype) {
                _data.payType = that.paytype;
            }
            const loading = this.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.3)'
            });
            this.tabLock = true;
            getProductList(_data)
                .then(function (res) {
                    console.log(res);
                    if (res.code == 1) {
                        that.tableData = res.data;
                        that.oldTableData = res.data;
                        that.commissionScope = [0, 100]; //佣金范围重置
                    } else {
                        that.tableData = [];
                        that.oldTableData = [];
                        that.commissionScope = [0, 100]; //佣金范围重置
                        // that.$message.error(res.msg);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                }).finally(() => {
                    loading.close();
                    this.tabLock = false;
                });
        },
        // 点击标签
        tabBtn(e, id) {
            if (id) {
                if (this[e].includes(id)) {
                    let index = this[e].indexOf(id);
                    this[e].splice(index, 1);
                } else {
                    this[e].push(id);
                }
            } else {
                this[e] = [];
            }
            this.getProductList();
        },
        cotImg(e) {
            this.cotImgNum = e;
            localStorage.setItem("cotImgNum", this.cotImgNum);
        },
        //搜索佣金范围变化
        changCommScope() {
            console.log(1111);
            var that = this;
            that.tableData = this.oldTableData.filter(item => {
                let proC = parseFloat(item.proCommission);
                if (
                    proC >= that.commissionScope[0] &&
                    proC <= that.commissionScope[1]
                ) {
                    return item;
                }
                console.log(proC);
            });
        }
    }
};
</script>
<style lang="scss">
.list {
    .top .topItem {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        margin-bottom: 10px;

        &>p {
            font-size: 14px;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.85);
            width: 80px;
            text-align: right;
            margin: 0;
            line-height: 28px;
            height: 28px;
        }

        &>.tagBox {
            margin-left: 10px;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex: 1;
            flex-wrap: wrap;
            overflow: hidden;

            p,
            span {
                margin: 0 15px 10px 0;
                padding: 2px 15px;
                height: 28px;
                cursor: pointer;
                border: 1px solid #fff;
                border-radius: 16px;
                transition: all 0.25s;
                font-size: 14px;
                line-height: 22px;
            }

            .activate {
                background: #ffffff;
                box-shadow: 0px 2px 10px 0px rgba(69, 159, 201, 0.34);
                border-color: #2d8aee;
                color: #2d8aee;
            }
        }

        &>.moreBtn {
            font-size: 14px;
            font-weight: 300;
            color: #2d8aee;
            cursor: pointer;
        }

        .el-checkbox-group {
            line-height: 28px;
            margin-left: 30px;
        }
    }

    .top .cotImg {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        div {
            cursor: pointer;
            margin-left: 15px;
            color: #444;

            i {
                // font-weight: bold;
                font-size: 18px;
            }
        }

        div.activate {
            color: #2d8aee;
        }
    }

    .top .topItem.commission {
        &>div {
            display: flex;
            align-items: center;
            cursor: pointer;

            &>span {
                margin-left: 30px;
                font-size: 14px;
                color: #606266;
            }

            .el-slider {
                width: 0px;
                opacity: 0;
                transition: all 0.3s;

                .el-slider__runway {
                    margin: 11px 20px;
                }
            }
        }

        &>div:hover .el-slider {
            width: 300px;
            opacity: 1;
        }
    }

    .list_bottomBox {
        padding: 10px 0 0;

        .el-table {
            th {
                background: #f1f4f8;
            }

            th,
            td {
                font-size: 14px;
                color: rgba(0, 0, 0, 0.85);
            }

            .cell {
                margin-left: 20px;
            }
        }

        .cardBox {
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;

            &>div.item {
                background: #fafbfb;
                border-radius: 20px 1px 20px 1px;
                border: 1px solid #e7e7e7;
                overflow: hidden;
                width: calc(20% - 16px);
                cursor: pointer;
                transition: all 0.25s;
                margin-right: 20px;
                margin-bottom: 20px;

                .imgBox {
                    height: 250px;
                    overflow: hidden;

                    img {
                        width: 100%;
                        min-height: 100%;
                    }
                }

                .textBox {
                    background: #fafbfb;
                    padding: 25px 25px 30px;

                    p {
                        font-size: 16px;
                        font-weight: 600;
                        color: #000000;
                        margin: 0 0 15px;
                    }

                    span {
                        background: #ffffff;
                        border-radius: 3px;
                        border: 1px solid #eb851c;
                        display: inline-block;
                        margin-right: 10px;
                        font-size: 14px;
                        font-weight: 400;
                        color: #eb851c;
                        padding: 2px 8px;
                        margin-bottom: 10px;

                        i {
                            margin-right: 5px;
                            vertical-align: middle;
                        }
                    }

                    span+span {
                        margin-right: 0;
                    }

                    div {
                        div {
                            margin-top: 15px;
                            background: #ffffff;
                            border: 1px solid #d2d2d2;
                            border-radius: 5px;
                            width: 95px;
                            font-size: 14px;
                            font-weight: 400;
                            color: #616161;
                            line-height: 20px;
                            padding: 5px 17px;
                            transition: all 0.25s;
                            display: inline-block;
                        }

                        p {
                            font-size: 14px;
                            font-weight: 400;
                            color: rgb(228, 110, 34);
                            display: inline-block;
                            margin: 0 0 0 15px;

                            span {
                                border: none;
                                padding: 0;
                            }
                        }
                    }
                }
            }

            &>div.item:hover {
                box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.1);

                .textBox div div {
                    background: #2d8aee;
                    color: #ffffff;
                }
            }

            &>div.item:nth-child(5n) {
                margin-right: 0;
            }
        }
    }
}

.el-tooltip__popper {
    max-width: 500px;
}

@media screen and (max-width: 1760px) {
    .list {
        .cardBox {
            &>div.item {
                width: calc(25% - 15px);
            }

            &>div.item:nth-child(5n) {
                margin-right: 20px;
            }

            &>div.item:nth-child(4n) {
                margin-right: 0;
            }
        }
    }
}

@media screen and (max-width: 1440px) {
    .list {
        .cardBox {
            &>div.item {
                width: calc(33.33% - 13.34px);
            }

            &>div.item:nth-child(4n) {
                margin-right: 20px;
            }

            &>div.item:nth-child(3n) {
                margin-right: 0;
            }
        }
    }
}

.searchform .el-select-dropdown__item {
    max-width: 300px !important;
}

.searchform .el-row .el-form-item {
    width: 100%;
    display: flex;

    .el-form-item__content {
        flex: 1;

        .el-select {
            width: 100%;
        }

        .el-date-editor {
            width: 100%;
            height: 33px;

            .el-range-separator {
                width: 24px;
            }
        }

        &>button {
            i {
                margin-right: 10px;
            }
        }

        &>button:first-child {
            margin-left: 55px;
            color: #3097f7;
            border-color: #3097f7;
        }

        &>button:first-child:hover {
            background-color: #ecf5ff;
        }
    }
}
</style>
